import { Card, Heading, Paragraph, Tag } from '@digdir/designsystemet-react';
import { CalendarIcon, LocationPinIcon } from '@navikt/aksel-icons';
import './jobAd.css';

const SOON_IS_DAYS_FROM_NOW = 7;

function isDeadlineSoon(deadline) {
	const now = new Date();
	const oneWeekFromNow = new Date(); // Lager en kopi av nåværende tidspunkt
	oneWeekFromNow.setDate(now.getDate() + SOON_IS_DAYS_FROM_NOW);

	const [day, month, year] = deadline.split('.').map(Number);
	const deadlineDate = new Date(year, month - 1, day); //

	return deadlineDate <= oneWeekFromNow;
}
const tagBackground = 'tag-background';
export const JobAd = (props: { [key: string]: any }) => {
	return (
		<Card className="job-ad-box" variant="tinted" asChild>
			<a href={props.link}>
				<Card.Block>
					<Heading>{props.title}</Heading>
				</Card.Block>
				<Card.Block>
					<Paragraph>{props.summary}</Paragraph>
				</Card.Block>
				<Card.Block>
					<Paragraph>
						<LocationPinIcon
							role="none"
							aria-hidden="true"
							fontSize="1.5rem"
						/>
						{props.location}
					</Paragraph>
					<Paragraph>
						<CalendarIcon
							role="none"
							aria-hidden="true"
							fontSize="1.5rem"
						/>
						Søknadsfrist: {props.deadline}
					</Paragraph>

					{isDeadlineSoon(props.deadline) && (
						<Tag data-color={tagBackground} data-size="md">
							Søknadsfristen nærmer seg
						</Tag>
					)}
				</Card.Block>
			</a>
		</Card>
	);
};
